import { createAsyncThunk } from "@reduxjs/toolkit";
import {handleErrorResponse} from '../../apis'
import axios from 'axios';

import LocalStorage from "../../utils/storage";

const ROLE = LocalStorage.getItem('userRole');

export const createSkuSampleMaterial = createAsyncThunk('createSkuSampleMaterial', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}v1/india-supply/create-sku-material/UI/product_sample`
  try {
      const response = await axios.post(URL, data)
      return response
  } catch (error) {
      return handleErrorResponse(error, rejectWithValue)
  }
});

export const getSampleMaterial = createAsyncThunk('getSampleMaterial', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}v1/india-supply/get-materials/product_sample`
  try {
      const response = await axios.post(URL, data)
      return response
  } catch (error) {
      return handleErrorResponse(error, rejectWithValue)
  }
});

export const captureMeasurementPosition = createAsyncThunk('captureMeasurementPosition', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}v1/india-supply/capture-measurement-positions/UI/${data?.sample_id}`
  try {
      delete data?.sample_id
      const response = await axios.post(URL, data)
      return response
  } catch (error) {
      return handleErrorResponse(error, rejectWithValue)
  }
});

export const uploadCaptureMeasurementPosition = createAsyncThunk('uploadCaptureMeasurementPosition', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}v1/india-supply/capture-measurement-positions/file_upload/${data?.sample_id}`

  let bodyFormData = new FormData();
    bodyFormData.append('file', data.file);
    try {
        const response = await axios.post(URL, bodyFormData, {headers: { "Content-Type": "multipart/form-data" }},)
        return response
    } catch (error) {
        return handleErrorResponse(error, rejectWithValue)
    }
});

export const captureSampleDetails = createAsyncThunk('captureSampleDetails', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}/v1/india-supply/capture-sample-details/${data?.sample_id}`
  try {
      delete data?.sample_id
      const response = await axios.post(URL, data)
      return response
  } catch (error) {
      return handleErrorResponse(error, rejectWithValue)
  }
});

export const downloadTechPack = createAsyncThunk('downloadTechPack', async (data, {rejectWithValue}) => {
  const URL = `${process.env.REACT_APP_API_BASE_URL}v1/india-supply/create-tech-pack/${data?.material_id}`
  try {
      const response = await axios.post(URL, data)
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'tech_pack.pdf');
      document.body.appendChild(link);
      link.click();
      return response
  } catch (error) {
      if (error.response.status === 401) {
          LocalStorage.clear()
          window.location.href = '/login'
      }
      if (error.response.status !== 200) {
          return rejectWithValue({ message: error.response.data.message })
      }
      return rejectWithValue({message: 'Something went wrong!'})
  }
});